/**
 * Zietta Landing Page — Shopify Theme JS
 * Full mix-and-match bundle backend via Shopify Cart AJAX API.
 * Custom boxes are stored as line item properties on the "Eigen Box" product.
 */

document.addEventListener('DOMContentLoaded', () => {

  // ══════════════════════════════════════
  //  CONFIG (injected from Liquid)
  // ══════════════════════════════════════

  const configEl = document.getElementById('zietta-config');
  if (!configEl) return;
  const CONFIG = JSON.parse(configEl.textContent);
  const BUNDLE_HEROS = CONFIG.bundleHeros || {};   // Per-bundle hero/slider images (6 each)
  const BUNDLE_THUMBS = CONFIG.bundleThumbs || {};  // Per-bundle thumbnail images (6 each)
  const IMG_LOGO = CONFIG.logo || '';
  const IMG_ROSA = CONFIG.rosa || '';

  // ══════════════════════════════════════
  //  SCROLL LOCK
  // ══════════════════════════════════════

  let scrollLockCount = 0;

  function lockScroll() {
    if (scrollLockCount === 0) {
      const scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--scrollbar-width', scrollbarW + 'px');
      document.body.classList.add('no-scroll');
    }
    scrollLockCount++;
  }

  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.body.classList.remove('no-scroll');
      document.documentElement.style.removeProperty('--scrollbar-width');
    }
  }

  // ══════════════════════════════════════
  //  DISH & BOX DATA
  // ══════════════════════════════════════

  // ── Dish data now comes from Shopify product pickers (CONFIG.boxDishes) ──
  // Each bundle has up to 6 dishes with title, description, and image from the theme editor.
  // Hero images come from BUNDLE_HEROS, thumbnails from BUNDLE_THUMBS.
  const boxDishesData = CONFIG.boxDishes || {};

  // ── Build boxData from Shopify product info (CONFIG.boxProducts) ──
  // Falls back to hardcoded defaults when no product is configured.
  const BP = CONFIG.boxProducts || {};

  function buildBox(key, defaults) {
    const p  = BP[key] || {};
    const price = p.price || defaults.price;            // in cents
    const euros = (price / 100).toFixed(2).replace('.', ',');
    const per   = (price / 100 / 12).toFixed(2).replace('.', ',');
    // Always use custom CDN images for the hero slider — never product images
    return {
      title:         p.title || defaults.title,
      subtitle:      p.description || defaults.subtitle,
      price:         price / 100,
      priceLabel:    '€' + euros,
      pricePer:      '€' + per + ' per gerecht',
      variantId:     CONFIG.variantIds[key],
      sliderImages:  defaults.sliderImages,
      sliderAlts:    defaults.sliderAlts,
    };
  }

  const boxData = {
    classica: buildBox('classica', {
      title: 'La Box Classica',
      subtitle: '12 authentieke Italiaanse gerechten, handgemaakt met verse ingrediënten uit Italië. Van pasta tot dolci — alles wat je nodig hebt voor een echte Italiaanse eetervaring.',
      price: 8995,
      sliderImages: (BUNDLE_HEROS.classica || []).filter(Boolean),
      sliderAlts:   ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4', 'Slide 5', 'Slide 6'],
    }),
    famiglia: buildBox('famiglia', {
      title: 'La Box Famiglia',
      subtitle: 'Extra grote porties voor het hele gezin. Dezelfde authentieke smaken, maar dan in family-size. Perfect voor een Italiaanse avond met de familie.',
      price: 10995,
      sliderImages: (BUNDLE_HEROS.famiglia || []).filter(Boolean),
      sliderAlts:   ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4', 'Slide 5', 'Slide 6'],
    }),
    vegana: buildBox('vegana', {
      title: 'La Box Vegana',
      subtitle: '12 plantaardige Italiaanse gerechten zonder compromis op smaak. Gemaakt met seizoensgroenten en ambachtelijke pasta, 100% diervriendelijk.',
      price: 9495,
      sliderImages: (BUNDLE_HEROS.vegana || []).filter(Boolean),
      sliderAlts:   ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4', 'Slide 5', 'Slide 6'],
    }),
    quarta: buildBox('quarta', {
      title: 'La Box Quarta',
      subtitle: '12 speciaal geselecteerde gerechten — een unieke combinatie van onze populairste recepten.',
      price: 9995,
      sliderImages: (BUNDLE_HEROS.quarta || []).filter(Boolean),
      sliderAlts:   ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4', 'Slide 5', 'Slide 6'],
    }),
  };

  // ══════════════════════════════════════
  //  SHOPIFY CART API
  // ══════════════════════════════════════

  async function shopifyCartAdd(variantId, quantity, properties) {
    const body = {
      items: [{
        id: variantId,
        quantity: quantity || 1,
      }],
    };
    if (properties && Object.keys(properties).length) {
      body.items[0].properties = properties;
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('Cart add failed');
    return res.json();
  }

  async function shopifyCartGet() {
    const res = await fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' },
    });
    return res.json();
  }

  async function shopifyCartChange(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    return res.json();
  }

  // ══════════════════════════════════════
  //  PRICE FORMATTING
  // ══════════════════════════════════════

  function formatPrice(cents) {
    // Shopify prices are in cents; convert to euros with comma decimal
    const euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  // ══════════════════════════════════════
  //  SLIDER
  // ══════════════════════════════════════

  const sliderEl = document.getElementById('heroSlider');
  const dotsEl = document.getElementById('sliderDots');
  const prevBtn = document.getElementById('sliderPrev');
  const nextBtn = document.getElementById('sliderNext');
  let currentSlide = 0;
  let slideCount = 0;
  let autoSlideTimer;

  function buildSlider(images, alts) {
    currentSlide = 0;
    sliderEl.innerHTML = images.map((src, i) =>
      `<div class="slide${i === 0 ? ' active' : ''}"><img src="${src}" alt="${alts[i]}" loading="${i === 0 ? 'eager' : 'lazy'}"></div>`
    ).join('');
    dotsEl.innerHTML = images.map((_, i) =>
      `<button class="dot${i === 0 ? ' active' : ''}" data-index="${i}" aria-label="Slide ${i + 1}"></button>`
    ).join('');
    slideCount = images.length;
    dotsEl.querySelectorAll('.dot').forEach(dot => {
      dot.addEventListener('click', () => goToSlide(parseInt(dot.dataset.index)));
    });
    resetAutoSlide();
  }

  function goToSlide(index) {
    const slides = sliderEl.querySelectorAll('.slide');
    const dots = dotsEl.querySelectorAll('.dot');
    if (!slides.length) return;
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');
    currentSlide = (index + slideCount) % slideCount;
    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
    resetAutoSlide();
  }

  function resetAutoSlide() {
    clearInterval(autoSlideTimer);
    autoSlideTimer = setInterval(() => goToSlide(currentSlide + 1), 5000);
  }

  prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
  nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));

  // ══════════════════════════════════════
  //  DISHES GRID
  // ══════════════════════════════════════

  const dishesGrid = document.getElementById('dishesGrid');

  function buildDishesGrid(boxKey) {
    // Use theme editor product data (boxDishes) for the dishes showcase grid.
    // Shows first 4 dishes from the selected bundle. Images come from BUNDLE_HEROS.
    const dishes = boxDishesData[boxKey] || [];
    const heroImages = BUNDLE_HEROS[boxKey] || [];
    const gridDishes = dishes.slice(0, 4);

    dishesGrid.innerHTML = gridDishes.map((d, i) => {
      const imgSrc = heroImages[i] || d.image || '';
      const name = d.title || '';
      const desc = (d.description || '').replace(/<[^>]*>/g, '').substring(0, 100);
      return `
        <div class="dish-card" data-dish-index="${i}">
          <div class="dish-image"><img src="${imgSrc}" alt="${name}" loading="lazy"></div>
          <div class="dish-info"><h3>${name}</h3><p>${desc}</p></div>
        </div>`;
    }).join('');

    dishesGrid.querySelectorAll('.dish-card').forEach(card => {
      card.addEventListener('click', () => {
        const idx = parseInt(card.dataset.dishIndex, 10);
        const d = dishes[idx];
        if (d) openDishPopup({
          img:  heroImages[idx] || d.image || '',
          name: d.title || '',
          long: d.description || ''
        });
      });
    });
  }

  // Dish info popup
  function openDishPopup(dish) {
    let popup = document.getElementById('dishPopup');
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'dishPopup';
      popup.className = 'dish-popup';
      popup.innerHTML = `
        <div class="dish-popup-overlay" id="dishPopupOverlay"></div>
        <div class="dish-popup-card" id="dishPopupCard">
          <button class="dish-popup-close" id="dishPopupClose" aria-label="Sluiten">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <img class="dish-popup-img" id="dishPopupImg" src="" alt="">
          <div class="dish-popup-body">
            <h3 class="dish-popup-name" id="dishPopupName"></h3>
            <div class="dish-popup-desc" id="dishPopupDesc"></div>
          </div>
        </div>`;
      document.body.appendChild(popup);
      document.getElementById('dishPopupOverlay').addEventListener('click', closeDishPopup);
      document.getElementById('dishPopupClose').addEventListener('click', closeDishPopup);
    }
    document.getElementById('dishPopupImg').src = dish.img;
    document.getElementById('dishPopupImg').alt = dish.name;
    document.getElementById('dishPopupName').textContent = dish.name;
    document.getElementById('dishPopupDesc').innerHTML = dish.long;
    popup.classList.add('open');
    lockScroll();
  }

  function closeDishPopup() {
    const popup = document.getElementById('dishPopup');
    if (popup) {
      popup.classList.remove('open');
      unlockScroll();
    }
  }

  // ══════════════════════════════════════
  //  BOX PREVIEW (inline expandable)
  // ══════════════════════════════════════

  const boxPreview = document.getElementById('boxPreview');
  const boxPreviewToggle = document.getElementById('boxPreviewToggle');
  const boxPreviewThumbs = document.getElementById('boxPreviewThumbs');
  const boxPreviewExpanded = document.getElementById('boxPreviewExpanded');

  function buildBoxPreview(boxKey) {
    // Show 6 cards — first 3 visible, next 3 in expanded area
    // All data comes from theme editor product pickers (boxDishes).
    // Thumb images come from BUNDLE_THUMBS CDN, hero images from BUNDLE_HEROS.
    const dishes = boxDishesData[boxKey] || [];
    const bundleThumbArr = BUNDLE_THUMBS[boxKey] || [];
    const heroImages = BUNDLE_HEROS[boxKey] || [];
    const sixDishes = dishes.slice(0, 6);
    const first3 = sixDishes.slice(0, 3);
    const rest = sixDishes.slice(3);

    function renderThumb(d, index) {
      if (!d) return '';
      const thumbSrc = bundleThumbArr[index] || d.image || '';
      const name = d.title || '';
      return `<div class="box-thumb" data-dish-index="${index}"><img src="${thumbSrc}" alt="${name}"><div class="box-thumb-name">${name}</div></div>`;
    }

    boxPreviewThumbs.innerHTML = first3.map((d, i) => renderThumb(d, i)).join('');
    boxPreviewExpanded.innerHTML = rest.map((d, i) => renderThumb(d, i + 3)).join('');

    boxPreview.classList.remove('open');
    if (boxPreviewToggle) {
      boxPreviewToggle.querySelector('span').textContent = 'Zie alle 6 gerechten';
    }

    // On thumb click: open popup with hero image + product description from theme editor
    boxPreview.querySelectorAll('.box-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.dishIndex, 10);
        const d = dishes[idx];
        if (d) {
          openDishPopup({
            img:  heroImages[idx] || d.image || '',
            name: d.title || '',
            long: d.description || ''
          });
        }
      });
    });
  }

  if (boxPreviewToggle) {
    boxPreviewToggle.addEventListener('click', () => {
      boxPreview.classList.toggle('open');
      const label = boxPreviewToggle.querySelector('span');
      label.textContent = boxPreview.classList.contains('open') ? 'Minder tonen' : 'Zie alle 6 gerechten';
    });
  }

  // ══════════════════════════════════════
  //  BOX OPTION SELECTION
  // ══════════════════════════════════════

  const optionCards = document.querySelectorAll('.option-card');
  let selectedBox = 'classica';
  let stickyReady = false;

  // URL slug ↔ box key mapping
  const boxToSlug = {
    classica:  'italian-classics',
    famiglia:  'italian-coast',
    vegana:    'italian-forest',
    quarta:    'italian-meat-gusto'
  };
  const slugToBox = Object.fromEntries(Object.entries(boxToSlug).map(([k, v]) => [v, k]));

  function selectBox(boxKey, updateUrl) {
    selectedBox = boxKey;
    const box = boxData[boxKey];
    document.getElementById('productTitle').textContent = box.title;
    document.getElementById('productSubtitle').textContent = box.subtitle;
    document.getElementById('priceCurrent').textContent = box.priceLabel;
    document.getElementById('pricePer').textContent = box.pricePer;
    buildSlider(box.sliderImages, box.sliderAlts);
    buildDishesGrid(boxKey);
    buildBoxPreview(boxKey);
    optionCards.forEach(c => c.classList.toggle('active', c.dataset.box === boxKey));
    if (stickyReady) updateStickyBar();

    // Update URL slug without page reload
    if (updateUrl !== false) {
      const slug = boxToSlug[boxKey];
      if (slug) {
        const url = new URL(window.location);
        url.search = slug;
        history.replaceState(null, '', url);
      }
    }
  }

  optionCards.forEach(card => {
    card.addEventListener('click', () => {
      selectBox(card.dataset.box);
      document.querySelector('.hero').scrollIntoView({ behavior: 'smooth' });
    });
  });

  // On page load: check URL for bundle slug and auto-select, otherwise default to classica
  const initialSlug = window.location.search.replace('?', '');
  const initialBox = slugToBox[initialSlug] || 'classica';
  selectBox(initialBox, initialSlug ? false : true);

  // ══════════════════════════════════════
  //  ACCORDION
  // ══════════════════════════════════════

  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      document.querySelectorAll('.accordion-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
      if (!isOpen) {
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ══════════════════════════════════════
  //  CART — Eurus theme slide cart integration
  //  Uses the theme's cart-drawer section.
  //  After AJAX cart ops we refresh the drawer
  //  via Section Rendering API and open it.
  // ══════════════════════════════════════

  const cartCountEl = document.getElementById('cartCount');
  const cartToggle = document.getElementById('cartToggle');
  const addToCartBtn = document.getElementById('addToCart');

  /**
   * Ensure the cart drawer (and its overlay) sit above our nav (z-100)
   * and banner (z-110).  Runs after every open / refresh so that newly
   * injected Eurus DOM also gets the override.
   */
  function liftCartZIndex() {
    // Target #CartDrawer and every sibling/child that Eurus renders
    // inside #ajax-loading-cart or #eurus-popup.
    const selectors = [
      '#CartDrawer',
      '#CartDrawer-Overlay',
      '[id*="CartDrawer"]',
      '#ajax-loading-cart > *',
      '#ajax-loading-cart .drawer.fixed',
      '#eurus-popup > *',
      '#eurus-popup .drawer.fixed',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(el => {
      el.style.setProperty('z-index', '99999', 'important');
    });
  }

  /**
   * Open the Eurus cart drawer AND make sure it is on top.
   * Pure client-side — no network calls.
   */
  function openCartDrawerInstantly() {
    if (window.Alpine) {
      const miniCart = Alpine.store('xMiniCart');
      if (miniCart) miniCart.open = true;
    }
    // Give Alpine one tick to render the drawer, then lift z-index
    requestAnimationFrame(liftCartZIndex);
  }

  /**
   * Refresh the cart drawer by fetching fresh section HTML from /cart
   * (guarantees latest cart state) and replacing the entire section content.
   * Uses Alpine.destroyTree/initTree for a clean re-initialization.
   */
  async function refreshCartDrawer() {
    try {
      // Fetch from /cart endpoint — ALWAYS reflects latest cart state
      const url = '/cart?sections=cart-drawer&_=' + Date.now();
      console.log('[Zietta] Fetching cart drawer from', url);
      const res = await fetch(url);
      if (!res.ok) {
        console.error('[Zietta] Cart section fetch failed:', res.status);
        return;
      }
      const json = await res.json();
      const html = json['cart-drawer'];
      if (!html) {
        console.error('[Zietta] No cart-drawer section in response');
        return;
      }

      console.log('[Zietta] Got cart HTML, length:', html.length);

      // Parse the fresh HTML to extract the inner content
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshCD = doc.getElementById('CartDrawer');
      if (!freshCD) {
        console.error('[Zietta] No #CartDrawer in fetched HTML');
        return;
      }

      // Find the LIVE CartDrawer — search within our container to avoid
      // duplicate ID issues if popups also renders one
      const container = document.getElementById('ajax-loading-cart');
      const liveCD = container
        ? container.querySelector('#CartDrawer')
        : document.getElementById('CartDrawer');

      if (!liveCD) {
        console.error('[Zietta] No live #CartDrawer in DOM');
        return;
      }

      // Swap the inner content of .drawer.fixed — this is INSIDE the
      // Alpine-managed #CartDrawer, so we preserve Alpine's outer
      // reactive bindings (x-show, x-cloak, x-data="xCart").
      // Only the rendered cart items / totals inside get replaced.
      const freshInner = freshCD.querySelector('.drawer.fixed');
      const liveInner = liveCD.querySelector('.drawer.fixed');

      if (freshInner && liveInner) {
        liveInner.innerHTML = freshInner.innerHTML;
        console.log('[Zietta] Swapped .drawer.fixed innerHTML');
      } else {
        // Fallback: swap entire CartDrawer children
        console.warn('[Zietta] .drawer.fixed not found, swapping full CartDrawer');
        liveCD.innerHTML = freshCD.innerHTML;
      }

      // Check if cart is empty after refresh
      const cartData = await shopifyCartGet();
      const isEmpty = !cartData || cartData.item_count === 0;

      if (window.Alpine) {
        const miniCart = Alpine.store('xMiniCart');
        if (miniCart) {
          miniCart.loading = false;
          // Only keep drawer open if cart has items
          if (isEmpty) {
            miniCart.open = false;
          } else {
            miniCart.open = true;
          }
        }
      }

      // Bind plain JS handlers on the new inner DOM nodes
      // (Alpine directives inside swapped content aren't reactive,
      //  but outer #CartDrawer x-show/close still works via Alpine)
      if (!isEmpty) {
        bindCartDrawerHandlers(liveCD);
      }

      // Re-trigger Zapiet initialization on the new DOM.
      // Zapiet listens for these events to re-bind its date/time pickers
      // and validation on dynamically updated cart content.
      try {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
        // Zapiet's own re-init hook (if available)
        if (window.Zapiet && typeof window.Zapiet.init === 'function') {
          window.Zapiet.init();
        }
        // Some Zapiet versions use ZapietWidget
        if (window.ZapietWidget && typeof window.ZapietWidget.init === 'function') {
          window.ZapietWidget.init();
        }
      } catch (zapErr) {
        console.warn('[Zietta] Zapiet re-init:', zapErr);
      }

      // Always sync the header cart badge after drawer refresh
      updateCartBadge();

      requestAnimationFrame(liftCartZIndex);

    } catch (e) {
      console.error('[Zietta] Cart drawer refresh failed:', e);
    }
  }

  /**
   * Bind click handlers on cart drawer elements after innerHTML swap.
   * Alpine directives on swapped-in DOM nodes aren't active, so we
   * attach plain JS listeners for core interactions.
   */
  function bindCartDrawerHandlers(cartDrawerEl) {
    // Close button
    const closeBtn = cartDrawerEl.querySelector('#CloseCart');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        if (window.Alpine) Alpine.store('xMiniCart').open = false;
      });
    }

    // Overlay click to close
    const overlay = cartDrawerEl.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        if (window.Alpine) Alpine.store('xMiniCart').open = false;
      });
    }

    // Checkout button — let Zapiet validate first, then go to checkout.
    // We do NOT preventDefault so Zapiet's own click listeners can run.
    // We only add a fallback: if Zapiet is not present, submit the form
    // with the button's name="checkout" so Shopify routes to /checkout.
    const checkoutBtn = cartDrawerEl.querySelector('#checkout-submit');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', (e) => {
        // Check if Zapiet widget exists and hasn't been validated
        const zapietWidget = document.querySelector(
          '[id*="zapiet"], .zapiet-delivery-date, [data-zapiet], ' +
          '#CartDrawer [name*="delivery"], #cart_form [name*="delivery"]'
        );
        // If Zapiet is present, let its own handlers deal with validation.
        // Zapiet re-binds after DOM changes via MutationObserver.
        if (zapietWidget) return; // Don't interfere — Zapiet handles it

        // No Zapiet detected — handle checkout ourselves
        e.preventDefault();
        const form = document.getElementById('cart_form');
        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit(checkoutBtn);
        } else {
          window.location.href = '/checkout';
        }
      });
    }

    // Quantity buttons — Eurus renders these with Alpine @click directives
    // that won't be active after innerHTML swap. We find them by their
    // surrounding quantity-selector structure and bind plain JS handlers.
    cartDrawerEl.querySelectorAll('.quantity-selector, [data-quantity-selector]').forEach(selector => {
      const input = selector.querySelector('input[type="number"], input[name="updates[]"]');
      if (!input) return;

      const buttons = selector.querySelectorAll('button');
      const minusBtn = buttons[0];  // First button is minus
      const plusBtn = buttons[1];   // Second button is plus

      // Determine the line index from the input name or data attribute
      // Eurus uses data-line or the input's index in the form
      const line = input.getAttribute('data-line') ||
                   input.getAttribute('data-index') ||
                   input.closest('[data-line]')?.getAttribute('data-line');

      if (minusBtn) {
        minusBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentQty = parseInt(input.value) || 1;
          const newQty = Math.max(0, currentQty - 1);
          await updateCartLine(line || getLineIndex(input, cartDrawerEl), newQty);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const currentQty = parseInt(input.value) || 1;
          await updateCartLine(line || getLineIndex(input, cartDrawerEl), currentQty + 1);
        });
      }
    });

    // Remove / delete item links
    cartDrawerEl.querySelectorAll('a[href*="/cart/change"], button[data-remove], .cart-remove').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const href = btn.getAttribute('href') || '';
        const lineMatch = href.match(/line=(\d+)/);
        const line = lineMatch ? lineMatch[1] : btn.closest('[data-line]')?.getAttribute('data-line');
        if (line) await updateCartLine(line, 0);
      });
    });
  }

  /**
   * Get the 1-based line index of a quantity input within the cart form.
   */
  function getLineIndex(input, container) {
    const allInputs = container.querySelectorAll('input[name="updates[]"]');
    for (let i = 0; i < allInputs.length; i++) {
      if (allInputs[i] === input) return i + 1;  // Shopify lines are 1-based
    }
    return 1;
  }

  /**
   * Update a cart line item quantity and refresh the drawer.
   */
  async function updateCartLine(line, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: quantity })
      });
      await refreshCartDrawer();
      updateCartBadge();
    } catch (e) {
      console.error('[Zietta] Cart line update failed:', e);
    }
  }

  /**
   * Update the Zietta header cart badge count.
   */
  async function updateCartBadge() {
    try {
      const cart = await shopifyCartGet();
      // Update Zietta header badge
      cartCountEl.textContent = cart.item_count;
      cartCountEl.classList.toggle('visible', cart.item_count > 0);

      // Update Eurus cart-icon-bubble (theme header)
      const eurusBubble = document.getElementById('cart-icon-bubble');
      if (eurusBubble) {
        eurusBubble.setAttribute('data-value', cart.item_count);
        const countSpan = eurusBubble.querySelector('span');
        if (countSpan) countSpan.textContent = cart.item_count;
      }

      // Update Eurus Alpine store item count
      if (window.Alpine) {
        const cartHelper = Alpine.store('xCartHelper');
        if (cartHelper) cartHelper.currentItemCount = cart.item_count;
      }
    } catch (e) { /* silent */ }
  }

  // ══════════════════════════════════════
  //  GLOBAL CART CHANGE INTERCEPTOR
  // ══════════════════════════════════════
  // Intercept ALL fetch calls to /cart/change.js and /cart/add.js
  // so the header badge updates regardless of what triggers the change
  // (Eurus Alpine, Zapiet, our handlers, or any other script).
  const _originalFetch = window.fetch;
  window.fetch = function(...args) {
    const result = _originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    if (url.includes('/cart/change') || url.includes('/cart/add') || url.includes('/cart/update')) {
      result.then(() => {
        // Small delay to let Shopify process the change
        setTimeout(() => updateCartBadge(), 300);
      }).catch(() => {});
    }
    return result;
  };

  // Also intercept XMLHttpRequest for cart changes (Eurus Alpine may use XHR)
  const _originalXHROpen = XMLHttpRequest.prototype.open;
  const _originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._ziettaUrl = typeof url === 'string' ? url : '';
    return _originalXHROpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function(...args) {
    if (this._ziettaUrl &&
        (this._ziettaUrl.includes('/cart/change') ||
         this._ziettaUrl.includes('/cart/add') ||
         this._ziettaUrl.includes('/cart/update'))) {
      this.addEventListener('load', () => {
        setTimeout(() => updateCartBadge(), 300);
      });
    }
    return _originalXHRSend.apply(this, args);
  };

  // Also listen for Alpine-dispatched cart events from Eurus
  document.addEventListener('cart:change', () => setTimeout(updateCartBadge, 300));
  document.addEventListener('cart:updated', () => setTimeout(updateCartBadge, 300));
  window.addEventListener('cart:change', () => setTimeout(updateCartBadge, 300));

  // MutationObserver on cart drawer — catches Eurus Alpine DOM updates
  // (e.g., when Alpine removes an item and re-renders the cart list)
  const cartDrawerRoot = document.getElementById('CartDrawer') || document.getElementById('ajax-loading-cart');
  if (cartDrawerRoot) {
    let badgeDebounce = null;
    const cartObserver = new MutationObserver(() => {
      clearTimeout(badgeDebounce);
      badgeDebounce = setTimeout(updateCartBadge, 400);
    });
    cartObserver.observe(cartDrawerRoot, { childList: true, subtree: true });
  }

  // Header cart icon — opens the Eurus slide cart + refreshes in background
  cartToggle.addEventListener('click', async () => {
    openCartDrawerInstantly();
    await refreshCartDrawer();
  });

  // ── Add predefined box to Shopify cart ──
  // Opens drawer INSTANTLY, then adds item, refreshes drawer, and
  // also triggers the Eurus native refresh as a fallback.
  addToCartBtn.addEventListener('click', async () => {
    const box = boxData[selectedBox];
    if (!box.variantId) {
      alert('Product niet geconfigureerd. Stel het product in via de Shopify theme editor.');
      return;
    }

    addToCartBtn.classList.add('loading');
    flashButton(addToCartBtn);

    try {
      // 1. Add item to Shopify cart FIRST (must complete before drawer refresh)
      await shopifyCartAdd(box.variantId, 1);

      // 2. Refresh the drawer HTML with fresh server-rendered content
      //    (refreshCartDrawer also opens the drawer — no separate open call
      //     to avoid Eurus watchers firing a competing stale refresh)
      await refreshCartDrawer();
      updateCartBadge();
    } catch (e) {
      console.error('Add to cart failed:', e);
      alert('Er ging iets mis. Probeer het opnieuw.');
    } finally {
      addToCartBtn.classList.remove('loading');
    }
  });

  function flashButton(btn) {
    btn.innerHTML = `<span>Toegevoegd!</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12l5 5L20 7"/></svg>`;
    setTimeout(() => {
      btn.innerHTML = `<span>Toevoegen aan winkelmandje</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>`;
    }, 1500);
  }

  // Initial cart badge from server-rendered count
  (async () => { await updateCartBadge(); })();

  // ══════════════════════════════════════
  //  CUSTOM BOX BUILDER (Mix & Match)
  //  Products pulled from Shopify collection.
  //  Price = sum of individual product prices.
  //  Count = total items selected (max 12).
  // ══════════════════════════════════════

  const customBoxProducts = CONFIG.customBoxProducts || [];

  const customBoxModal = document.getElementById('customBoxModal');
  const customBoxOverlay = document.getElementById('customBoxOverlay');
  const customBoxGrid = document.getElementById('customBoxGrid');
  const customCountEl = document.getElementById('customCount');
  const customProgressFill = document.getElementById('customProgressFill');
  const customPriceEl = document.getElementById('customPrice');
  const customLabelEl = document.getElementById('customLabel');
  const customCheckoutBtn = document.getElementById('customCheckout');
  const customBoxCloseBtn = document.getElementById('customBoxClose');
  const openCustomBoxBtn = document.getElementById('openCustomBox');

  const CUSTOM_BOX_MAX = 12; // maximum items allowed in the bundle
  let customSelections = {}; // keyed by product handle → quantity

  function getCustomProduct(handle) {
    return customBoxProducts.find(p => p.handle === handle);
  }

  function openCustomBox() {
    customSelections = {};
    customBoxProducts.forEach(p => { customSelections[p.handle] = 0; });
    expandedDish = null;
    renderCustomGrid();
    updateCustomCounter();
    customBoxModal.classList.add('open');
    customBoxOverlay.classList.add('open');
    lockScroll();
  }

  function closeCustomBox() {
    customBoxModal.classList.remove('open');
    customBoxOverlay.classList.remove('open');
    unlockScroll();
  }

  openCustomBoxBtn.addEventListener('click', openCustomBox);
  customBoxCloseBtn.addEventListener('click', closeCustomBox);
  customBoxOverlay.addEventListener('click', closeCustomBox);

  function getCustomTotal() {
    return Object.values(customSelections).reduce((a, b) => a + b, 0);
  }

  function getCustomTotalPrice() {
    let total = 0;
    Object.entries(customSelections).forEach(([handle, qty]) => {
      if (qty > 0) {
        const p = getCustomProduct(handle);
        if (p) total += p.price * qty;
      }
    });
    return total; // in cents
  }

  function updateCustomCounter() {
    const totalItems = getCustomTotal();
    const totalPrice = getCustomTotalPrice();
    const remaining  = CUSTOM_BOX_MAX - totalItems;

    // Progress bar
    const pct = Math.min((totalItems / CUSTOM_BOX_MAX) * 100, 100);
    customCountEl.textContent = totalItems;
    customProgressFill.style.width = `${pct}%`;
    if (totalItems === CUSTOM_BOX_MAX) {
      customProgressFill.classList.add('complete');
    } else {
      customProgressFill.classList.remove('complete');
    }

    // Footer price — dynamic sum
    customPriceEl.textContent = formatPrice(totalPrice);

    // Footer label — dynamic count with limit
    if (totalItems === 0) {
      customLabelEl.textContent = `0 / ${CUSTOM_BOX_MAX} gerechten`;
    } else if (totalItems === 1) {
      customLabelEl.textContent = `1 / ${CUSTOM_BOX_MAX} gerecht`;
    } else {
      customLabelEl.textContent = `${totalItems} / ${CUSTOM_BOX_MAX} gerechten`;
    }

    // Checkout button — enabled only when exactly 12 items selected
    if (totalItems === CUSTOM_BOX_MAX) {
      customCheckoutBtn.disabled = false;
      customCheckoutBtn.innerHTML = `<span>Toevoegen aan winkelmandje — ${formatPrice(totalPrice)}</span>`;
    } else if (totalItems > 0) {
      customCheckoutBtn.disabled = true;
      customCheckoutBtn.innerHTML = `<span>Nog ${remaining} gerecht${remaining === 1 ? '' : 'en'} kiezen</span>`;
    } else {
      customCheckoutBtn.disabled = true;
      customCheckoutBtn.innerHTML = '<span>Kies gerechten</span>';
    }

    // Disable all plus buttons when limit reached
    if (customBoxGrid) {
      customBoxGrid.querySelectorAll('.custom-btn-plus').forEach(btn => {
        btn.disabled = totalItems >= CUSTOM_BOX_MAX;
      });
      customBoxGrid.querySelectorAll('.custom-dish-detail-add').forEach(btn => {
        btn.disabled = totalItems >= CUSTOM_BOX_MAX;
      });
    }
  }

  let expandedDish = null;

  function renderCustomGrid() {
    const total = getCustomTotal();
    customBoxGrid.innerHTML = customBoxProducts.map(p => {
      const count = customSelections[p.handle] || 0;
      const isExpanded = expandedDish === p.handle;
      return `
        <div class="custom-dish${count > 0 ? ' selected' : ''}${isExpanded ? ' expanded' : ''}" data-id="${p.handle}">
          <div class="custom-dish-row" data-toggle="${p.handle}">
            <div class="custom-dish-img">
              <img src="${p.image}" alt="${p.title}" loading="lazy">
              ${count > 0 ? `<div class="custom-dish-badge">${count}</div>` : ''}
            </div>
            <div class="custom-dish-info">
              <span class="custom-dish-name">${p.title}</span>
              <span class="custom-dish-desc">${formatPrice(p.price)}</span>
            </div>
            <svg class="custom-dish-expand-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
            <div class="custom-dish-actions">
              <button class="custom-btn-minus" data-id="${p.handle}" ${count === 0 ? 'disabled' : ''}>\u2212</button>
              <span class="custom-dish-count">${count}</span>
              <button class="custom-btn-plus" data-id="${p.handle}" ${total >= CUSTOM_BOX_MAX ? 'disabled' : ''}>+</button>
            </div>
          </div>
          <div class="custom-dish-detail">
            <div class="custom-dish-detail-wrap">
              <div class="custom-dish-detail-inner">
                <img class="custom-dish-detail-img" src="${p.imageLarge || p.image}" alt="${p.title}" loading="lazy">
                <div class="custom-dish-detail-text">
                  <h4>${p.title}</h4>
                  <p>${p.longDescription || p.description}</p>
                  <p style="margin-top:8px;font-weight:600;">${formatPrice(p.price)} per stuk</p>
                  <button class="custom-dish-detail-add" data-id="${p.handle}" ${total >= CUSTOM_BOX_MAX ? 'disabled' : ''}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    Toevoegen
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');

    // Toggle expand on row click
    customBoxGrid.querySelectorAll('.custom-dish-row').forEach(row => {
      row.addEventListener('click', (e) => {
        if (e.target.closest('.custom-btn-minus') || e.target.closest('.custom-btn-plus')) return;
        const id = row.dataset.toggle;
        expandedDish = expandedDish === id ? null : id;
        renderCustomGrid();
        updateCustomCounter();
        if (expandedDish) {
          setTimeout(() => {
            const el = customBoxGrid.querySelector(`.custom-dish[data-id="${expandedDish}"]`);
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 50);
        }
      });
    });

    // Plus buttons — capped at CUSTOM_BOX_MAX (12)
    customBoxGrid.querySelectorAll('.custom-btn-plus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (getCustomTotal() >= CUSTOM_BOX_MAX) return;
        customSelections[btn.dataset.id]++;
        renderCustomGrid();
        updateCustomCounter();
      });
    });

    customBoxGrid.querySelectorAll('.custom-btn-minus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (customSelections[btn.dataset.id] > 0) {
          customSelections[btn.dataset.id]--;
          renderCustomGrid();
          updateCustomCounter();
        }
      });
    });

    // Add button in the expanded detail — capped at CUSTOM_BOX_MAX (12)
    customBoxGrid.querySelectorAll('.custom-dish-detail-add').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (getCustomTotal() >= CUSTOM_BOX_MAX) return;
        customSelections[btn.dataset.id]++;
        renderCustomGrid();
        updateCustomCounter();
      });
    });
  }

  // Add custom bundle to Shopify cart.
  // Adds the "Eigen Box" parent variant + individual child items.
  // Cart Transform merges them into a single displayed bundle.
  // OPTIMISTIC: close modal + open drawer instantly → fire API → refresh on success
  customCheckoutBtn.addEventListener('click', async () => {
    const totalItems = getCustomTotal();
    if (totalItems !== CUSTOM_BOX_MAX) return; // must be exactly 12

    const parentVariantId = CONFIG.variantIds.custom;
    if (!parentVariantId) return;

    let items;

    // ── FoxSell / Opus payload ──────────────────────────
    if (CONFIG.foxsell && CONFIG.foxsell.bundleId) {
      const identifier = CONFIG.foxsell.bundleId + '_' + Date.now();
      const categoryName = CONFIG.foxsell.categoryName || 'default';

      // Build the bundle items array for FoxSell
      const bundleItems = [];
      Object.entries(customSelections).forEach(([handle, qty]) => {
        if (qty > 0) {
          const p = getCustomProduct(handle);
          if (p) {
            bundleItems.push({
              variantId: String(p.variantId),
              quantity: qty,
              category: categoryName,
              type: 'product'
            });
          }
        }
      });

      if (bundleItems.length === 0) return;

      // Single line item with FoxSell properties
      items = [{
        id: parentVariantId,
        quantity: 1,
        properties: {
          '__foxsell:dynamic_add_on_bundle_id': identifier,
          '__foxsell:dynamic_add_on_bundle_items': JSON.stringify(bundleItems)
        }
      }];

      console.log('[Zietta] FoxSell bundle payload:', {
        identifier,
        itemCount: bundleItems.length,
        totalQty: bundleItems.reduce((s, i) => s + i.quantity, 0)
      });

    // ── Fallback: legacy _bundle_group payload ──────────
    } else {
      const bundleId = 'bundle-' + Date.now();
      items = [];

      items.push({
        id: parentVariantId,
        quantity: 1,
        properties: {
          '_bundle_group':  bundleId,
          '_bundle_parent': 'true',
          '_bundle_label':  'Eigen Box'
        }
      });

      Object.entries(customSelections).forEach(([handle, qty]) => {
        if (qty > 0) {
          const p = getCustomProduct(handle);
          if (p) {
            items.push({
              id: p.variantId,
              quantity: qty,
              properties: {
                '_bundle_group': bundleId,
                '_bundle_label': 'Eigen Box'
              }
            });
          }
        }
      });

      if (items.length === 0) return;
    }

    // 2. Close the custom-box modal while we add items
    customCheckoutBtn.disabled = true;
    customCheckoutBtn.innerHTML = '<span>Bezig met toevoegen...</span>';
    closeCustomBox();

    // 3. Add items to Shopify cart, then refresh drawer
    const payload = { items };
    console.log('[Zietta] Custom box cart payload:', JSON.stringify(payload, null, 2));
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errorBody = await res.text();
        console.error('[Zietta] Cart add failed:', res.status, errorBody);
        throw new Error('Cart add failed: ' + res.status + ' — ' + errorBody);
      }
      const cartResponse = await res.json();
      console.log('[Zietta] Cart add success:', cartResponse);

      // 4. Items added — refresh drawer (also opens it)
      await refreshCartDrawer();
      updateCartBadge();
    } catch (e) {
      console.error('[Zietta] Custom box add error:', e);
      alert('Er ging iets mis. Probeer het opnieuw.\n\nDetails: ' + e.message);
    } finally {
      updateCustomCounter();
    }
  });

  // ══════════════════════════════════════
  //  STEP SCROLL ANIMATION
  // ══════════════════════════════════════

  const stepsSection = document.querySelector('.how-it-works');
  if (stepsSection) {
    let stepsAnimated = false;
    const stepObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !stepsAnimated) {
          stepsAnimated = true;
          document.querySelectorAll('.step').forEach(s => s.classList.add('animate-in'));
          stepObserver.disconnect();
        }
      });
    }, { threshold: 0.3 });
    stepObserver.observe(stepsSection);
  }

  // ══════════════════════════════════════
  //  STICKY BOTTOM BAR
  // ══════════════════════════════════════

  const stickyBar = document.getElementById('stickyBar');
  const stickyDropdown = document.getElementById('stickyDropdown');
  const stickyTrigger = document.getElementById('stickyDropdownTrigger');
  const stickyOptions = document.getElementById('stickyOptions');
  const stickyBoxName = document.getElementById('stickyBoxName');
  const stickyBoxPrice = document.getElementById('stickyBoxPrice');
  const stickyAddToCart = document.getElementById('stickyAddToCart');
  const stickyTriggerEl = document.getElementById('addToCart');

  const stickyBoxMap = {
    classica: { name: boxData.classica.title, price: boxData.classica.priceLabel },
    famiglia: { name: boxData.famiglia.title, price: boxData.famiglia.priceLabel },
    vegana:   { name: boxData.vegana.title,   price: boxData.vegana.priceLabel },
    quarta:   { name: boxData.quarta.title,   price: boxData.quarta.priceLabel },
    custom:   { name: 'Eigen box samenstellen', price: '—' },
  };

  function updateStickyBar() {
    const info = stickyBoxMap[selectedBox] || stickyBoxMap.classica;
    stickyBoxName.textContent = info.name;
    stickyBoxPrice.textContent = info.price;
    stickyOptions.querySelectorAll('.sticky-bar-option').forEach(opt => {
      opt.classList.toggle('active', opt.dataset.box === selectedBox);
    });
  }

  if (stickyTriggerEl && stickyBar) {
    const barObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
    }, { threshold: 0 });
    barObserver.observe(stickyTriggerEl);
  }

  if (stickyTrigger) {
    stickyTrigger.addEventListener('click', () => {
      stickyDropdown.classList.toggle('open');
    });
  }

  if (stickyOptions) {
    stickyOptions.querySelectorAll('.sticky-bar-option').forEach(opt => {
      opt.addEventListener('click', () => {
        const boxKey = opt.dataset.box;
        if (boxKey === 'custom') {
          openCustomBox();
        } else {
          selectBox(boxKey);
          // Don't scroll to top — just update the sticky bar in place
        }
        updateStickyBar();
        stickyDropdown.classList.remove('open');
      });
    });
  }

  if (stickyAddToCart) {
    stickyAddToCart.addEventListener('click', async () => {
      if (selectedBox === 'custom') {
        openCustomBox();
        return;
      }
      const box = boxData[selectedBox];
      if (!box || !box.variantId) {
        alert('Product niet geconfigureerd.');
        return;
      }
      // Optimistic: show spinner briefly, add to cart, open drawer instantly
      const origHTML = stickyAddToCart.innerHTML;
      stickyAddToCart.classList.add('loading');
      stickyAddToCart.disabled = true;
      stickyAddToCart.innerHTML = '<span class="spinner"></span>';
      try {
        // Add to cart (fast API call)
        await shopifyCartAdd(box.variantId, 1, {});
        // Show success immediately
        stickyAddToCart.innerHTML = '<span>✓</span>';
        // Open drawer right away (don't wait for refresh)
        openCartDrawerInstantly();
        // Restore button after brief flash
        setTimeout(() => {
          stickyAddToCart.innerHTML = origHTML;
          stickyAddToCart.classList.remove('loading');
          stickyAddToCart.disabled = false;
        }, 900);
        // Refresh drawer content + badge in background
        refreshCartDrawer();
        updateCartBadge();
      } catch (e) {
        console.error('[Zietta] Sticky add-to-cart failed:', e);
        stickyAddToCart.innerHTML = origHTML;
        stickyAddToCart.classList.remove('loading');
        stickyAddToCart.disabled = false;
        alert('Er ging iets mis. Probeer het opnieuw.');
      }
    });
  }

  document.addEventListener('click', (e) => {
    if (stickyDropdown && !stickyDropdown.contains(e.target)) {
      stickyDropdown.classList.remove('open');
    }
  });

  stickyReady = true;
  updateStickyBar();

  // ══════════════════════════════════════
  //  ANNOUNCEMENT BANNER COUNTDOWN
  // ══════════════════════════════════════

  (function initBanner() {
    const banner = document.getElementById('announcementBanner');
    const closeBtn = document.getElementById('announcementClose');
    if (!banner) return;

    function getNextFriday() {
      const now = new Date();
      const fri = new Date(now);
      fri.setHours(12, 0, 0, 0);
      const day = fri.getDay();
      const daysUntilFri = (5 - day + 7) % 7;
      if (daysUntilFri === 0 && now >= fri) {
        fri.setDate(fri.getDate() + 7);
      } else {
        fri.setDate(fri.getDate() + daysUntilFri);
      }
      return fri;
    }

    const deadline = getNextFriday();

    function updateCountdown() {
      const diff = Math.max(0, deadline - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      document.getElementById('countDays').textContent = d;
      document.getElementById('countHours').textContent = String(h).padStart(2, '0');
      document.getElementById('countMins').textContent = String(m).padStart(2, '0');
      document.getElementById('countSecs').textContent = String(s).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);

    closeBtn.addEventListener('click', () => {
      banner.classList.add('hidden');
      document.documentElement.style.setProperty('--banner-height', '0px');
    });
  })();

});
